// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchDish_container__39NKs","space":"SearchDish_space__PYvhf"};